import axios from 'axios';

/**
 * Axios instance for the auth/identity service (BASE_AUTH_URL).
 * Kept separate from `apiClient` because the auth service may live on a
 * different host in production, and these requests are unauthenticated
 * (the Authorization header is set per-call with the Firebase ID token).
 */
export const authClient = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_AUTH_URL,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});
